import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export default function BanUser() {
  const location = useLocation();
  const [timeLeft, setTimeLeft] = useState('');
  const [reason, setReason] = useState('Violation of terms of service');
  const [banDate, setBanDate] = useState('');
  const [banExpiry, setBanExpiry] = useState('');

  useEffect(() => {
    // Parse ban details from location state or query params
    const searchParams = new URLSearchParams(location.search);
    const banReason = searchParams.get('reason') || 'Violation of terms of service';
    const expiryDate = searchParams.get('expiry') || '';

    setReason(banReason);

    if (expiryDate) {
      const expiry = new Date(expiryDate);
      setBanDate(expiry.toLocaleDateString());

      // Calculate time left
      const updateTimer = () => {
        const now = new Date();
        const diff = expiry - now;

        if (diff <= 0) {
          setTimeLeft('Ban has expired');
          clearInterval(timer);
          return;
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

        setTimeLeft(`${days}d ${hours}h ${minutes}m`);
      };

      updateTimer();
      const timer = setInterval(updateTimer, 60000);

      return () => clearInterval(timer);
    }
  }, [location]);

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100%",
        display: "grid",
        placeItems: "center",
        padding: "var(--sp-4)",
        boxSizing: "border-box",
      }}
    >
      <section
        className="panel"
        role="alert"
        aria-live="polite"
        style={{ width: "100%", maxWidth: 440, padding: "var(--sp-7) var(--sp-6)", textAlign: "center" }}
      >
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: "999px",
            margin: "0 auto var(--sp-4)",
            display: "grid",
            placeItems: "center",
            background: "var(--accent-dark)",
            color: "var(--accent-dark-ink)",
            boxShadow: "0 12px 30px -12px rgba(178,58,82,.55)",
          }}
        >
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
            />
          </svg>
        </div>

        <h1 style={{ fontSize: 22, fontWeight: 700, color: "var(--error)" }}>Account Restricted</h1>
        <p style={{ fontSize: 13, color: "var(--text-2)", marginTop: 6, marginBottom: "var(--sp-5)" }}>
          Your account has been temporarily suspended
        </p>

        <div
          style={{
            background: "var(--surface-2)",
            border: "1px solid var(--border)",
            borderRadius: "var(--radius-md)",
            padding: "var(--sp-4)",
            textAlign: "left",
            marginBottom: "var(--sp-5)",
          }}
        >
          <div style={{ marginBottom: banDate || timeLeft ? "var(--sp-3)" : 0 }}>
            <p style={{ fontSize: 11.5, color: "var(--text-3)" }}>Reason for restriction:</p>
            <p style={{ fontSize: 13, color: "var(--text-1)", fontWeight: 600, marginTop: 2 }}>{reason}</p>
          </div>

          {banDate && (
            <div style={{ marginBottom: timeLeft ? "var(--sp-3)" : 0 }}>
              <p style={{ fontSize: 11.5, color: "var(--text-3)" }}>Restriction applied on:</p>
              <p className="num" style={{ fontSize: 13, color: "var(--text-1)", fontWeight: 600, marginTop: 2 }}>
                {banDate}
              </p>
            </div>
          )}

          {timeLeft && (
            <div>
              <p style={{ fontSize: 11.5, color: "var(--text-3)" }}>Time remaining:</p>
              <p className="num" style={{ fontSize: 13, color: "var(--warning)", fontWeight: 600, marginTop: 2 }}>
                {timeLeft}
              </p>
            </div>
          )}
        </div>

        <p style={{ fontSize: 11.5, color: "var(--text-3)", marginBottom: "var(--sp-5)" }}>
          If you believe this is a mistake, please contact our support team with your account details.
        </p>

        <div style={{ display: "flex", flexWrap: "wrap", gap: 10, justifyContent: "center" }}>
          <a href="/" className="btn btn-ghost">
            Return Home
          </a>
          <a href="mailto:leoclubofsliit@gmail.com" className="btn btn-danger">
            Contact Support
          </a>
        </div>
      </section>
    </div>
  );
}
